import {Component} from 'react'
import {Field, reduxForm, change} from 'redux-form'
import {connect} from 'react-redux'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import Input from '../../Form/Field/Input.jsx'
import Select from '../../Form/Field/Select.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import CityTypeahead from '../../Form/Field/CityTypeahead.jsx'
import Date from '../../Form/Field/Date.jsx'
import ExpertiseTypeahead from '../../Form/Field/ExpertiseTypeahead.jsx'
import SecteurTypehead from '../../Form/Field/SecteurTypeahead.jsx'
import Quill from '../../Form/Field/Quill.jsx'
import validate from './validate.js'
import withLogos from '../../../HOC/withLogos.jsx'
import withManagers from '../../../HOC/withManagers.jsx'
import api from "../../../../api.js"

import './OfferForm.scss'

export const name = 'OfferForm'

class OfferForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      universes: [],
      subUniverses: [],
      managers: [],
      universesLoaded: false,
      hasInitializedUniverse: false,
    }
  }

  async componentDidMount() {
    await this.fetchUniverses()
  }

  componentDidUpdate(prevProps, prevState) {
    const universeFromProps = this.props?.initialValues?.offer?.universe
    const universeNowDefined = universeFromProps !== undefined

    if (
      this.state.universesLoaded &&
      universeNowDefined &&
      !this.state.hasInitializedUniverse
    ) {
      this.initializeUniverse(universeFromProps)
    }
  }

  fetchUniverses = async () => {
    try {
      const response = await api.universes.getAll()
      const universes = response?.data || []

      this.setState(
        { universes, universesLoaded: true },
        () => {
          const initialUniverse = this.props?.initialValues?.offer?.universe

          if (initialUniverse !== undefined) {
            this.initializeUniverse(initialUniverse)
          } else if (universes.length) {
            this.initializeUniverse(universes[0]?.id)
          }
        }
      )
    } catch (error) {
      console.error('Error fetching universes:', error)
    }
  }

  initializeUniverse = (universeId) => {
    this.getSubUniverseByUniverseId(universeId)
    this.fetchOfferManagersByUniverse(universeId)
    this.setState({ hasInitializedUniverse: true })
  }

  fetchOfferManagersByUniverse = async (universeId) => {
    if (!universeId) return

    try {
      const response = await api.users.getBusinessManagersByUniverse({ universe: universeId })
      this.setState({ managers: response.data || [] })
    } catch (error) {
      console.error('Error fetching managers:', error)
    }
  }

  getSubUniverseByUniverseId = (universeId) => {
    const found = this.state.universes.find(u => Number(u.id) === Number(universeId))
    this.setState({ subUniverses: found?.sub_universes || [] })
  }

  onChange = (event, universeId) => {
    this.getSubUniverseByUniverseId(universeId)
    this.fetchOfferManagersByUniverse(universeId)
    this.props.dispatch(change(name, 'offer.sub_universes', []))
    return universeId
  }

  render() {
    const { universes, subUniverses} = this.state

    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            {!this.props.hasProfilePicture &&
              this.props.isBusinessManager &&
              <div className="col-mb-12 alert alert-danger small">
                Votre profil est incomplet. Pour pouvoir créer une annonce et en être le/la responsable, vous devez
                uploader une image de profil.
              </div>
            }

            <div className="mb-auto col-md-12">
              <Field
                label="Publier mission en : "
                name="offer.universe"
                multiple={false}
                onChange={this.onChange}
                component={Select}>
                {universes.map((universe) => (
                  <option value={universe?.id} key={`universe-option-${universe?.id}`}>{universe.name}</option>
                ))}
              </Field>
            </div>

            <div className="mb-auto col-md-12">
              <Field
                label="Titre : *"
                name="offer.title"
                placeholder="Consultant Achats..."
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-auto col-md-6">
              <Field
                label="Responsable de l'offre : "
                name="offer.manager"
                multiple={false}
                component={Select}>
                <option/>
                {this.state.managers.map((manager) => (
                  <option value={manager?.id} key={`manager-option-${manager?.id}`}>{manager.fullname}</option>
                ))}
              </Field>
            </div>
            <div className="mb-auto col-md-6">
              <Field
                label="Sous-catégories : *"
                name="offer.sub_universes"
                type="selected"
                multiple={true}
                component={Select}>
                {subUniverses.map((subUniverse) => (
                  <option value={subUniverse?.id} key={`sub-universe-${subUniverse?.id}`}>{subUniverse.name}</option>
                ))}
              </Field>
            </div>
          </div>
          <div className="row">
            <div className="mb-auto col-md-6">
              <Field
                label="Lieu de la mission : *"
                name="offer.city"
                placeholder="Paris, Bordeaux..."
                type="text"
                component={CityTypeahead}
              />
            </div>
            <div className="mb-auto col-md-6">
              <Field
                label="Nom du client (Non publié) :"
                name="offer.client_name"
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-auto col-md-12">
              <Field
                label="Secteur d'activité :"
                name="offer.secteurs"
                placeholder="ex: Automobile"
                component={SecteurTypehead}
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-auto col-md-6">
              <Field
                label="Date de début de la mission : *"
                name="offer.start_date"
                type="text"
                placeholder="jj/mm/aaaa"
                component={Date}
              />
            </div>
            <div className="mb-auto col-md-6">
              <Field
                label="Durée de la mission : *"
                name="offer.duration"
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-auto col-md-6">
              <Field
                label="TJM indicatif (&euro;) :"
                name="offer.tjm_text"
                type="text"
                component={Input}
              />
            </div>
            <div className="mb-auto col-md-6">
              <Field
                label="Expérience requise :"
                name="offer.experiences"
                type="text"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Mots clés : *"
                name="offer.keywords"
                placeholder="ex: Douane, GDPR..."
                component={ExpertiseTypeahead}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Sélectionner un logo : *</label>
                <Field name="offer.logo" component={
                  ({meta}) => meta.error && meta.touched ? <div className="error-msg">Veuillez sélectionner un logo</div> : ''
                }/>
                <div className="available-logos">
                  {this.props.logos.map((logo) => {
                    return (
                      <label key={logo?.id} className="logo">
                        <Field name="offer.logo" component="input" type="radio" value={logo?.id} parse={value => Number(value)}/>
                        <img className="logo-image" src={logo?.imageUrl} alt={logo?.label}/>
                      </label>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Description de la mission"
                name="offer.description"
                component={Quill}
              />
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.loading || this.props.submitting || this.props.triggerSubmit}/>
      </div>
    )
  }
}

const ReduxOfferForm = reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(OfferForm)

export default connect(
  state => ({
    currentUniverseSubUniverses: state.universe?.currentUniverse?.sub_universes?.length ? state.universe.currentUniverse.sub_universes : [],
    hasProfilePicture: !!state.currentUser?.user?.image,
    isBusinessManager: state.currentUser?.user?.isBusinessManager,
  })
)(withManagers(withLogos(ReduxOfferForm)))
